/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const ApiCommet = axios.create({ baseURL: 'https://apicommet.inmet.gov.br' });

export default ApiCommet;
